import React from 'react';
import CreateDreamForm from '../components/CreateDreamForm';
import { useAuth } from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';

const CreateDreamPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-dream-200 animate-pulse">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-dream-900 text-dream-50">
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8 sm:mb-12">
            <p className="hidden sm:block text-dream-300 text-sm sm:text-base">
              Share your dream with the world or keep it private. Your choice.
            </p>
          </div>

          <div className="bg-dream-800/50 border border-dream-700/30 rounded-xl p-4 sm:p-6 shadow-lg">
            <CreateDreamForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateDreamPage; 